module.exports = __webpack_public_path__ + "img/story-2.16d3f903.jpg";